// extracted by mini-css-extract-plugin
export default {"userRoleWrapper":"UserManagemenetUsers_userRoleWrapper__ooZAq"};